module.exports = __webpack_public_path__ + "static/media/img008.7fe4ffd2.jpg";